module.exports = __webpack_public_path__ + "img/9788964371282.b697622d.jpg";